import React, { useCallback } from 'react';
import Confirm from 'components/UI/Confirm';
import { useToggle } from 'hooks';

function useConfirm({
  open: defaultState,
  title,
  message,
  cancelText,
  confirmText,
  onConfirm,
  onCancel,
  additionalProps,
}) {
  const [open, toggle] = useToggle(defaultState);

  const handleConfirm = useCallback(() => {
    toggle();
    if (typeof onConfirm === 'function') {
      onConfirm();
    }
  }, [toggle, onConfirm]);

  const handleCancel = useCallback(() => {
    toggle();
    if (typeof onCancel === 'function') {
      onCancel();
    }
  }, [toggle, onCancel]);

  return [
    toggle,
    useCallback(
      () => (
        <Confirm
          onCancel={handleCancel}
          onConfirm={handleConfirm}
          open={open}
          title={title}
          message={message}
          cancelText={cancelText}
          confirmText={confirmText}
          {...additionalProps}
        />
      ),
      [cancelText, confirmText, message, handleConfirm, handleCancel, open, title]
    ),
  ];
}

export default useConfirm;
